import { Avatar, AvatarSkeleton } from "@clipboard-health/ui-components";
import type { AvatarSize } from "@clipboard-health/ui-theme";

interface WorkerAvatarProps {
  size?: AvatarSize;
  profilePictureUrl?: string;
  isLoading?: boolean;
}

export function WorkerAvatar(props: WorkerAvatarProps) {
  const { size, profilePictureUrl, isLoading } = props;

  if (isLoading) {
    return <AvatarSkeleton size={size} />;
  }

  return <Avatar src={profilePictureUrl} size={size} />;
}
